var uievents = require('./events');

module.exports = function(items, addform, Constructor, store, tracker) {
	var _t = this;

	Object.defineProperty(_t, 'store', {
		get: function() { return _t._store; },
		set: function(s) {
			if (s === _t.store) return;
			_t._store = s;
			if (s && typeof(s) == 'object') {
				on(s, 'change').then(function() {
					_t.restore();
				});
			}
		}
	});

	this.store = store;
	this.addform = addform;
	this.tracker = tracker;
	this.items = items;

	var onchange = on(this, 'change');
	var onadd = on(this, 'add');
	var onremove = on(this, 'remove');
	var onselect = on(this, 'select');
	var onrestore = on(this, 'restore');
	var onsave = on(this, 'save');
	var onerror = on(this, 'error');

	this.add = function(item) {
		var added = add(item);
		if (this.store && typeof(this.store.save) == 'function') {
			onchange.fire();
			this.store.save(added).then(function(id) {
				added.$id = id;
				if (_t.tracker) _t.tracker.trackEvent(added.tagName, 'add');
				onsave.fire();
			})
		// 	.catch(function(err) {
		// 		alert('Item could not be saved.');
		// 		location.reload();
		// 	});
		} else {
			if (_t.tracker) _t.tracker.trackEvent(added.tagName, 'add');
			onchange.fire(item);
		}
	};

	this.remove = function(item) {
		var i = items.indexOf(item);
		if (i >= 0) {
			if (item.$id && this.store && typeof(this.store.remove) == 'function') {
				onchange.fire();
				this.store.remove(item.$id).then(function() {
					if (_t.tracker) _t.tracker.trackEvent(items[i].tagName, 'remove');
					items.splice(i,1);
					onsave.fire();
				}).catch(function(err) {
					alert('Item could not be saved.');
				});
			} else {
				if (_t.tracker) _t.tracker.trackEvent(items[i].tagName, 'remove');
				items.splice(i,1);
				onchange.fire(item);
			}
			onremove.fire(item);
		}
	};

	var add = function(item) {
		// item.parentNode?.removeChild(item);
		// item = new Constructor({...item});
		const addedItem = items._push(item) && items[items.length - 1];
		on(addedItem, 'change').then(function() { onchange.fire(addedItem); });
		on(addedItem, 'remove').then(function() { _t.remove(addedItem); });
		on(addedItem, 'select').then(function() { onselect.fire(addedItem); });
		onadd.fire(addedItem);
		return addedItem;
	};

	var replaceItemsWith = function(newItems) {
		newItems = newItems && isa(newItems, Array) ? newItems : [];
		items.splice(0);
		newItems.forEach(function(item) { add(item); } );
	};

	this.restore = function() {
		if (this.store && this.store.getIndex) {
			this.store.getIndex().then(function(_items) {
				replaceItemsWith(_items);
				onrestore.fire();
			});
		}
	};

	this.save = function() {
		if (_t.store && typeof(_t.store.saveAll) == 'function') {
			_t.store.saveAll(items).then(function(savedItems) {
				savedItems.forEach(function(item, i) {
					items[i].$id = item.$id;
				});
				onsave.fire();
			}).catch(function(err) {
				onerror.fire(err);
				alert(err.message);
				if (err.message == 'Not authenticated.') {
					document.location.reload();
				}
			});
			return true;
		} 
		return false;
	};

	this.saveItem = function(item) {
		if (_t.store && typeof(_t.store.save) == 'function') {
			_t.store.save(item).then(function(id) {
				item.$id = id;
				onsave.fire();
			}).catch(function(err) {
				onerror.fire(err);
				alert(err.message);
				if (err.message == 'Not authenticated.') {
					document.location.reload();
				}
			});
			return true;
		} 
		return false;
	};

	var saveTimer = null;
	onchange.then(function(changeSource) {
		if (!_t.store || changeSource == null) return;
		saveTimer ? clearTimeout(saveTimer) : 0;
		saveTimer = setTimeout(function() {
			saveTimer = null;
			_t.saveItem(changeSource) ? 0 : _t.save();
		}, 2000);
	});

	items._push = items.push;
	items.push = function(item) {
		_t.add(item);
	};

	if (_t.addform) {
		on(_t.addform, 'add').then(function(item) {
			_t.add(item);
		});
	}

}
